import React, { VFC } from 'react'

import { Button } from '@Components/Button'
import { ButtonWithProgress } from '@Components/Button/ButtonWithProgress'
import { BuyButtonProps } from '@Components/BuyButton/index'
import { useTranslation } from '@Globals/Translations'

type BuyButtonElementProps =
  Partial<BuyButtonProps>
  & {
    inProgress?: boolean
    onClick: () => void
  }

export const BuyButtonElement: VFC<BuyButtonElementProps> = ({
  buttonColor,
  buttonText = '',
  className,
  disabled,
  id,
  inProgress = false,
  isSaleable,
  onClick,
  variant,
}) => {
  const { t } = useTranslation()

  if (!isSaleable) {
    return (
      <Button className={className} color="dark" disabled id={id} variant="outlined">
        {t('cms:SOLD_OUT_LABEL')}
      </Button>
    )
  }

  // Figure out the button text. If none is given from the source, we'll fall back to a default.
  const textToUse = buttonText || t('cms:ADD_TO_CART')

  return (
    <ButtonWithProgress
      className={className}
      color={buttonColor}
      disabled={disabled}
      id={id}
      loading={inProgress}
      onClick={onClick}
      variant={variant}
    >
      {textToUse}
    </ButtonWithProgress>
  )
}
